import { APIInfo, SecretKeyConfig } from '../components/context/AppContextModels';

// Enum representing keys used in AWS Secrets Manager.
export enum SecretManagerKeys {
  API_KEY = 'das-finsuite-app-apikey-secret',
  EVENTS_API_KEY = 'das-finsuite-app-events-apikey-secret'
}

// Configuration for Secret Key ARNs, required only for Dev and Alpha environments.
export const SecretKeyArnConfig: SecretKeyConfig[] = [
  {
    environment: 'dev',
    // If you are using personal stack update these values to be your secrets manager ARN
    // Example: arn:aws:secretsmanager:us-west-2:850882930567:secret:das-finsuite-app-apikey-secret_mkteja-GVhCk9
    secretARN: 'arn:aws:secretsmanager:us-west-2:850882930567:secret:das-finsuite-app-apikey-secret-Ib2Zj2'
  },
  {
    // If you are using personal stack update these values to be your secrets manager ARN
    // Example: arn:aws:secretsmanager:us-west-2:850882930567:secret:das-finsuite-app-apikey-secret_mkteja-GVhCk9
    environment: 'alpha',
    secretARN: 'arn:aws:secretsmanager:us-west-2:850882930567:secret:das-finsuite-app-apikey-secret-Ib2Zj2'
  }
];

// Configuration for backend GraphQL API endpoints based on environment.
export const BackendGraphQLApiConfig: APIInfo[] = [
  {
    environment: 'dev',
    // If you are using personal stack update these values to be your graphQL endpoints
    // Example: https://mblcwtv6a5g53b53rmti3shjwa.appsync-api.us-west-2.amazonaws.com/graphql
    finsuite_api: 'https://fmaiyn7m5nhkfdeymrb5chilkm.appsync-api.us-west-2.amazonaws.com/graphql',
    risk_remediator_api: 'https://risk-remediator-api-alpha.finsuite.device.finance.amazon.dev',
    fintech_papi: 'https://fintech-papi.device.finance.amazon.dev',
    baseball_card_api: 'https://alpha.baseball-card.finsuite.device.finance.amazon.dev',
    brass_api: 'https://beta.dasfinbrassapi.device.finance.amazon.dev',
    finsuite_rest_api: 'https://api.alpha.finsuite.device.finance.amazon.dev'
  },
  {
    environment: 'alpha',
    // If you are using personal stack update these values to be your graphQL endpoints
    // Example: https://mblcwtv6a5g53b53rmti3shjwa.appsync-api.us-west-2.amazonaws.com/graphql
    finsuite_api: 'https://fmaiyn7m5nhkfdeymrb5chilkm.appsync-api.us-west-2.amazonaws.com/graphql',
    risk_remediator_api: 'https://risk-remediator-api-alpha.finsuite.device.finance.amazon.dev',
    fintech_papi: 'https://fintech-papi.device.finance.amazon.dev',
    baseball_card_api: 'https://alpha.baseball-card.finsuite.device.finance.amazon.dev',
    brass_api: 'https://beta.dasfinbrassapi.device.finance.amazon.dev',
    finsuite_rest_api: 'https://api.alpha.finsuite.device.finance.amazon.dev'
  },
  {
    environment: 'beta',
    finsuite_api: 'https://tby5i5xuvzhdrmppv3rkswz3va.appsync-api.us-west-2.amazonaws.com/graphql',
    risk_remediator_api: 'https://risk-remediator-api-beta.finsuite.device.finance.amazon.dev',
    fintech_papi: 'https://fintech-papi.device.finance.amazon.dev',
    baseball_card_api: 'https://beta.baseball-card.finsuite.device.finance.amazon.dev',
    brass_api: 'https://beta.dasfinbrassapi.device.finance.amazon.dev',
    finsuite_rest_api: 'https://api.beta.finsuite.device.finance.amazon.dev'
  },
  // TODO: Need to update baseball_card_api endpoint once we have onboarded to badge service, https://sim.amazon.com/issues/AccSys-16363
  {
    environment: 'prod',
    finsuite_api: 'https://y4dff7baobfzrotbxldlbhv3xu.appsync-api.us-west-2.amazonaws.com/graphql',
    risk_remediator_api: 'https://risk-remediator-api-prod.finsuite.device.finance.amazon.dev',
    fintech_papi: 'https://fintech-papi.device.finance.amazon.dev',
    baseball_card_api: 'https://baseball.finsuite.device.finance.amazon.dev',
    brass_api: 'https://dasfinbrassapi.device.finance.amazon.dev',
    finsuite_rest_api: 'https://api.finsuite.device.finance.amazon.dev'
  }
];
